export default "__VITE_ASSET__skBPWAgF__"